// Avec Route Browser
import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import oidcConfig from "./auth/authConfig";
import { AuthProvider } from 'react-oidc-context';
 
// import { ReactKeycloakProvider } from "@react-keycloak/web";
// import keycloak from "./auth/keycloak";

/** local | staging | prod — propriété super-globale `app_env` sur les événements. */
function resolveAppEnv() {
    const fromBuild = process.env.REACT_APP_ENV?.trim();
    if (fromBuild) return fromBuild;
    if (process.env.NODE_ENV === "development") return "local";
    if (typeof window !== "undefined") {
        const h = window.location.hostname.toLowerCase();
        if (h === "localhost" || h === "127.0.0.1" || h.endsWith(".local")) return "local";
        if (h.includes("staging") || h.includes("preprod")) return "staging";
    }
    return "prod";
}

// Même projet PostHog que greenmiles-frontend (clé publique, overridable via REACT_APP_*).
const POSTHOG_KEY_DEFAULT = "phc_DuCtFp7BaAiaGN4qx71wrhs7JE2wGGOMQNpMNhWm2Xv";
const POSTHOG_HOST_DEFAULT = "https://eu.i.posthog.com";
const posthogKey = process.env.REACT_APP_POSTHOG_KEY?.trim() || POSTHOG_KEY_DEFAULT;
const posthogHost = (process.env.REACT_APP_POSTHOG_HOST?.trim() || POSTHOG_HOST_DEFAULT).replace(/\/+$/, "");
const appEnv = resolveAppEnv();
const isPosthogDebugEnabled = process.env.REACT_APP_POSTHOG_DEBUG === "true" || appEnv === "staging";

posthog.init(posthogKey, {
    api_host: posthogHost,
    debug: process.env.NODE_ENV === "development" || isPosthogDebugEnabled,
    person_profiles: "always",
    // Événements / personnes / exceptions uniquement — pas de Session replay (replays restent côté Greenmiles).
    disable_session_recording: true,
    loaded: (ph) => {
        ph.register({
            app_env: appEnv,
            app_name: "luniapp",
            app_scope: "simulator_accor",
        });
        if (isPosthogDebugEnabled) {
            // Exposé volontairement pour diagnostics en pré-prod.
            // @ts-ignore - propriété de debug volontairement ajoutée au window global.
            window.posthog = ph;
            // Log minimal pour confirmer l'init et le projet cible.
            console.info("[posthog] initialized", { appEnv, posthogHost, tokenSuffix: posthogKey.slice(-6) });
        }
    },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <AuthProvider {...oidcConfig}>
        <App />
    </AuthProvider>
);

reportWebVitals();

//Avant Route Browser

// import React, { createContext, useState } from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";

// import { ReactKeycloakProvider } from "@react-keycloak/web";
// import keycloak from "./auth/keycloak";

// // Context
// // import HotelContext from './context/HotelContext'

// const root = ReactDOM.createRoot(document.getElementById("root"));

// root.render(
//     <ReactKeycloakProvider authClient={keycloak}>
//         <App />
//     </ReactKeycloakProvider>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
